import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from './config';
import { getCompany } from './companyState';

let client: SupabaseClient | null = null;

/** Bọc fetch để mọi yêu cầu mang đơn vị đang làm việc (header x-company-id). */
export const withCompanyHeader = (f: typeof fetch): typeof fetch => (input, init) => {
  const h = new Headers(init?.headers);
  h.set('x-company-id', getCompany());
  return f(input, { ...init, headers: h });
};

/** Tạo khi cần dùng lần đầu, để màn hình báo thiếu cấu hình vẫn hiển thị được khi chưa có khóa. */
export function supabase(): SupabaseClient {
  if (!client) {
    client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
      realtime: { params: { eventsPerSecond: 10 } },
      // mọi yêu cầu REST/RPC mang đơn vị đang làm việc; CSDL dùng header này để tách dữ liệu theo đơn vị
      global: { fetch: withCompanyHeader(fetch.bind(globalThis)) },
    });
  }
  return client;
}

/** Thay client (dùng trong test). */
export function setSupabaseForTest(c: SupabaseClient | null): void { client = c; }
